module.exports = __webpack_public_path__ + "static/media/User_Selling_Points_Image.2dfd0e79.png";